import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, iif } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { AccountInfoService } from '~core/modules/identity/services/account-info.service';

@Injectable()
export class EntrepreneurStatusGuard implements CanActivate {
  constructor(
    private router: Router,
    private accountInfoService: AccountInfoService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const canAccessRoute = route.data.canAccessRoute;

    const isWaitingForValidation$ = this.accountInfoService.getAccountStatus().pipe(
      map((accountStatus: string) => {
        if (canAccessRoute(accountStatus)) {
          return true;
        }

        const redirectUrl = route.data.redirectUrl;
        const redirectUrlTree = this.router.parseUrl(redirectUrl);
        redirectUrlTree.queryParams = route.queryParams;

        return redirectUrlTree;
      })
    );

    return this.accountInfoService.isEntrepreneur().pipe(
      switchMap(isEntrepreneur => iif((() => isEntrepreneur), isWaitingForValidation$, of(false))),
    );
  }
}
